module.exports = __webpack_public_path__ + "static/img/p7.53e5443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p7.png
// module id = jj+4
// module chunks = 0